import React, { useState } from 'react';
import api from '../util/api';

interface BulkImageUploadProps {
    onImagesUploaded: (cells: any[]) => void;
}

const generateId = () => Math.random().toString(36).substring(2, 15);

export const BulkImageUpload: React.FC<BulkImageUploadProps> = ({ onImagesUploaded }) => {
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (!files || files.length === 0) return;

        setUploading(true);
        setProgress(0);

        const uploadedCells: any[] = [];
        const fileList = Array.from(files);

        for (let i = 0; i < fileList.length; i++) {
            const file = fileList[i];
            const formData = new FormData();
            formData.append('file', file);

            try {
                const res = await api.post('/api/upload-file/', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                const cell = {
                    id: generateId(),
                    plugin: { id: 'custom-image-plugin', version: 1 },
                    dataI18n: { default: { url: res.data.fileUrl, alt: file.name } },
                    size: 4,
                    rows: [],
                    inline: null
                };
                uploadedCells.push(cell);
                setProgress(Math.round(((i + 1) / fileList.length) * 100));
            } catch (err) {
                console.error(`Failed to upload ${file.name}`, err);
            }
        }

        onImagesUploaded(uploadedCells);
        setUploading(false);
        setProgress(0);
        // Clear the input
        e.target.value = '';
    };

    return (
        <div className="bulk-upload-container">
            <input
                type="file"
                id="bulk-image-input"
                multiple
                accept="image/*"
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />
            <button
                className="bulk-upload-btn"
                onClick={() => document.getElementById('bulk-image-input')?.click()}
                disabled={uploading}
            >
                {uploading ? `Uploading (${progress}%)` : 'Bulk Upload Images'}
            </button>
            {uploading && (
                <div className="upload-progress-bar">
                    <div className="progress-fill" style={{ width: `${progress}%` }}></div>
                </div>
            )}
        </div>
    );
};
